module.exports = __webpack_public_path__ + "img/1.5998a940.jpg";